import { IAffiliateListTableLang } from '../../../types/lang'

export const affiliateListTableLang: IAffiliateListTableLang = {
	affiliate_list_table: {
		column_id: 'ID',
		column_name: 'Name',
		column_percent: 'Percent, %',
		column_notes: 'Notes'
	}
}